import React, { useState, useEffect, useRef } from 'react'
import { FormattedMessage } from 'react-intl'
import * as styles from './index.module.css'
import ArrowWhite from '../../../assets/images/ArrowWhite.svg'
import debounce from 'lodash/debounce'

const ExternalViz = ({ title, subtitle, components }) => {
  const component = components ? components[0] : {}
  const subtitleFrags = subtitle?.subtitle?.length
    ? subtitle?.subtitle?.split('\n')
    : []
  const [isOverlayVisible, setIsOverlayVisible] = useState(true)
  const [overlayTitle, setOverlayTitle] = useState('')
  const [overlayText, setOverlayText] = useState('')
  const [overlayButtonText, setOverlayButtonText] = useState('')
  const overlayButton = useRef(null)
  const iframe = useRef(null)
  let overlayVisibleTimeout

  const hideOverlay = (e) => {
    if (e && e.target === overlayButton.current) {
      return
    }
    overlayVisibleTimeout = window.setTimeout(() => {
      setIsOverlayVisible(true)
    }, 700)
  }

  const cancelHideOverlay = () => {
    window.clearTimeout(overlayVisibleTimeout)
  }

  /** Reload iframe src to get the canvas element in iframe to resize and fill the container again */
  useEffect(() => {
    const debouncedHandleResize = debounce(
      (e) => (iframe.current.src = subtitleFrags[0]),
      250
    )
    window.addEventListener('resize', debouncedHandleResize)
    return () => window.removeEventListener('resize', debouncedHandleResize)
  })
  /** Reload iframe src to get the canvas element in iframe to resize and fill the container again */
  useEffect(() => {
    document.addEventListener('touchend', hideOverlay)
    return () => document.removeEventListener('touchend', hideOverlay)
  })

  useEffect(() => {
    setOverlayText(component.title)
    setOverlayButtonText(component.ctaText)
    setOverlayTitle(component.title)
  }, [])

  if (
    subtitleFrags.length > 0 &&
    typeof window !== `undefined` &&
    window.innerWidth >= 450
  ) {
    return (
      <div className="wrapper">
        <div className={styles.container}>
          <div className={styles.descriptionBox}>
            <h2 className={styles.title}>{title}</h2>

            {subtitleFrags.length > 1 && (
              <div className={styles.subtitle}>{subtitleFrags[1]}</div>
            )}

            {isOverlayVisible && (
              <div className={styles.overlay}>
                <h2>{overlayTitle}</h2>
                <p>{overlayText}</p>
                <button
                  onClick={(e) => {
                    e.preventDefault()
                    setIsOverlayVisible(false)
                  }}
                  className={styles.overlayButton}
                  ref={overlayButton}
                >
                  {overlayButtonText}

                  <ArrowWhite className={styles.arrow} />
                </button>
              </div>
            )}

            <iframe
              ref={iframe}
              title="webviz"
              className={styles.viz}
              src={subtitleFrags[0]}
              width="100%"
              height="100%"
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              onMouseLeave={() => hideOverlay()}
              onMouseEnter={() => cancelHideOverlay()}
              onTouchStart={() => cancelHideOverlay()}
            />
          </div>
        </div>
      </div>
    )
  } else {
    return <div></div>
  }
}

export default ExternalViz
